// extracted by mini-css-extract-plugin
export default {"root":"Zdj82uUV","withPlaceholder":"gCHDi+0w"};